import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class RegexService {
  constructor() {}

  alphabetical = /^[a-zA-ZñÑáéíóúÁÉÍÓÚçäÄëïöÖÿÜü \'\`\´\-]+$/;

  numeric = /^[0-9]*$/;

  numericSpace = /^[0-9\s]*?$/;

  cuit = /^[0-9]{11}$/;

  dni = /^\d{8}(?:[-\s]\d{4})?$/;

  postalCode = /^[0-9]{4}$/;

  mail = /^\s*[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}\s*$/i;

  //password = /^(?=.*[a-z])[a-zA-Z\d]{8,}$/;
  passwordComplete = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;

  noZero = /^[1-9][0-9]*$/;

  numbersAndDecimals = /^\d+([.,]\d+)*$/;

  static passwordMatchValidator(control: AbstractControl) {
    let password = '',
      confirmPassword = '';
    password = control.value.password;
    confirmPassword = control.value.passwordRep;
    if (password !== confirmPassword) {
      control.get('passwordRep').setErrors({ NoPassswordMatch: true });
    }
  }
  //opcional el 54, el 9 , el 0 para el 11 y el 15 para celulares
  telefono = /^(?:(?:00)?549?)?0?(?:11|[2368]\d)(?:(?=\d{0,2}15)\d{2})??\d{10}$/;
}
